// extracted by mini-css-extract-plugin
export default {"ball":"Ball_ball__BUsUU","ballLeft":"Ball_ballLeft__8PdLs","bigBall":"Ball_bigBall__ZtvaY"};